import { createAction, props } from "@ngrx/store";
import { FullUserDetails } from "../../types/app-state";

export const resolveUserDetails = createAction(
  'User.ResolveDetails',
  props<{
    user: FullUserDetails;
  }>()
);
